export default __webpack_public_path__ + "static/media/bulldozer.1aaa3c90.png";